module.exports = __webpack_public_path__ + "img/pz.80c37e0f.png";